import * as React from "react";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { QuoteModel } from "../../../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import {
    getISTPaymentAmount,
    pensionInstrumentSelectionToInstrumentSelection,
} from "../../../../../../../Shared/IST/Components/Shared/Utils";
import { InvestmentSelectionTool as IST } from "../../../../../../../Shared/IST/InvestmentSelectionTool";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { AdviserContextStoreStatic } from "../../../../NewBusinessWizard/Stores/Variable";

interface IInvestmentSelectionToolProps extends IProcessComponentProps {
    data: QuoteModel;
}

interface IInvestmentSelectionToolState {}

export class InvestmentSelectionTool extends ProcessComponent<
    IInvestmentSelectionToolProps,
    IInvestmentSelectionToolState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { onChange, data } = this.props;
        const paymentAmount = getISTPaymentAmount(data?.ISAQuote, "IsaTransfers");
        const modelData = JSON.parse(JSON.stringify(data?.ISAQuote));
        modelData.CashInstrument = data.CashInstrument;
        modelData.OwnerHierarchyId = data.OwnerHierarchyId;
        const hasSipp = data.SelectedProducts.some((ele) =>
            SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)
        );
        const clAccountId = new URLSearchParams(window.location.search).get("clAccountId");
        const adviser = AdviserContextStoreStatic.getData();
        return (
            <div>
                <h2 className="mb-20">Investment selection</h2>
                <IST
                    withReRegistrationTransferIn={false}
                    data={data?.ISAQuote?.InstrumentSelections}
                    modelData={modelData}
                    onRef={(ref) => this.appendChild(ref)}
                    onChange={(changes) =>
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "ISAQuote"),
                            changes,
                            data.ISAQuote,
                            "InstrumentSelections"
                        )
                    }
                    from={hasSipp ? SubAccountType.Sipp : null}
                    fromData={
                        hasSipp
                            ? pensionInstrumentSelectionToInstrumentSelection(
                                  data.PensionQuote?.PreRetirementInstrumentSelections,
                                  data.PensionQuote?.PostRetirementInstrumentSelections,
                                  data.CashInstrument
                              )
                            : null
                    }
                    showErrorMsgPopUp={(msg) => this.props.showErrorMsgPopUp(msg)}
                    type={ProcessType.Quote}
                    hiercharyId={data?.ISAQuote?.HierarchyId}
                    headAccountHierarchyId={data.ExistingAccountHierarchyId}
                    companyCode={adviser.Company}
                    claccountId={clAccountId}
                    product={SubAccountType.StocksIsa}
                    paymentAmount={{ Amount: paymentAmount, Currency: CurrencyCode.GBP }}
                    bankAccounts={[]}
                    onBankChange={(bankInfo) => {}}
                    onDistributionDividendOptions={(changes) => {
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "ISAQuote"),
                            changes,
                            data.GiaQuote,
                            "DistributionDividendOptions"
                        );
                    }}
                    decisionMakerHierarchyId={data?.ISAQuote?.HierarchyId}
                    accountAdviceType={data?.AccountAdviceType}
                    accountServiceProposition={data?.AccountServiceProposition}
                    onDecisionMakerChange={(v) => this.onDataChange(onChange, v, data, "ISAQuote")}
                />
            </div>
        );
    }
}
